<div class = "lookup-form-wrap">
  <div class = "container p-0">
    <div class="form-wrap">
      <form [formGroup]="flightLookupForm" (ngSubmit)="onFormSubmit()">
        <div class="controls-wrap">
          <div class="form-group">
            <div class="help-block">
              <button type = "button" class="help-block-content unstyle-button " [attr.aria-label]="pageConstants.confirmationNumberHelpText" (click)="showTooltip($event)">
                <div class="help-text">{{pageConstants?.tooltipLabel}}</div>
                <div class="icon-wrap">
                  <span class="help-icon">?</span>
                </div>
              </button>
              <ua-tooltip *ngIf="isTooltipDisplayed">
                <p aria-live='polite' class="tooltip-body">{{pageConstants?.tooltip}}</p>
              </ua-tooltip>
            </div>
            <label for="pnr">
              {{ pageConstants[pnr.label]}}
              <span *ngIf="lastName.isRequired" class="required">({{ commonConstants.required }})</span>
            </label>
            <input type="text" class="form-control" id="pnr" [placeholder]="confirmationNumberPlaceHolder" formControlName="pnr" autocomplete="off" 
            (keyup)="pnrOnKeyup($event)" (focus)= "ispnrInputFocused = true" (blur) = "ispnrInputFocused = false"
            (input)="limitChars(pnr.maxLength,$event)"
            [maxlength]="pnr.maxLength" />
            <div class="error-block" *ngIf="pnrControl?.dirty && pnrControl?.invalid && !ispnrInputFocused">
              <div class="err-message" *ngIf="pnrControl?.errors?.required" role='alert'>
                <div class="error-icon">
                  <img src="./../../../assets/error.png" alt="error" />
                </div>
                <span>{{ pageConstants[pnr.required] }}</span>
              </div>
              <div class="err-message" *ngIf="pnrControl?.errors?.pattern" role='alert'>
                <div class="error-icon">
                  <img src="./../../../assets/error.png" alt="error" />
                </div>
                <span>{{pageConstants[pnr.error]}}</span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="lastName">
              {{ pageConstants[lastName.label] }}
              <span *ngIf="lastName.isRequired" class="required">({{ commonConstants?.required }})</span>
            </label>
            <input type="text" class="form-control" id="lastName" [placeholder]="lastNamePlaceHolder" formControlName="lastName" autocomplete="off" [maxlength]="lastName.maxLength"
            (focus) = "isLastNameInputFocused = true" (blur) = "isLastNameInputFocused = false"/>
            <div class="error-block" *ngIf="lastNameControl?.dirty && lastNameControl?.invalid">
              <div class="err-message" *ngIf="lastNameControl?.errors?.required" [attr.role]="isLastNameInputFocused? 'alert': '' ">
                <div class="error-icon">
                  <img src="./../../../assets/error.png" alt="error" />
                </div>
                <span>{{ pageConstants[lastName.required]}}</span>
              </div>
              <div class="err-message" *ngIf="lastNameControl?.errors?.pattern" [attr.role]="isLastNameInputFocused? 'alert': '' ">
                <div class="error-icon">
                  <img src="./../../../assets/error.png" alt="error" />
                </div>
                <span>{{ pageConstants[lastName.error] }}</span>
              </div>
            </div>
          </div> 
          <div class="cookie-consent-wrap">
            <ua-cookie-consent></ua-cookie-consent>
          </div>
          <div class="btn-wrap row">
            <button class="btn col-sm-8 col-md-6 col-lg-4" [class.disabled]="flightLookupForm.invalid || isLoading" [disabled]="flightLookupForm.invalid || isLoading">{{ commonConstants["submit"] }}</button>
          </div>
        </div>
      </form>
      <div class="link-text-wrap">
        <button type = 'button' class="link-text unstyle-button" (click)="redirectPage(true, true)">
          <span >{{pageConstants[linkText]}}</span>
        </button>
      </div>
    </div>
  </div>
</div>